"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* What the family's page derives from the form's view. */
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);
var _links = require('shared/services/forms/links');




const byPlace = (a, b) =>
  a.page - b.page || a.box.y - b.box.y || a.box.x - b.box.x

 const fieldsInOrder = (view) => [...(_nullishCoalesce(view.Fields, () => ( [])))].sort(byPlace); exports.fieldsInOrder = fieldsInOrder

/* The signer's steps: each field the family fills, in reading order. A form
 * without a signature box still ends with a signature step: submitting needs
 * a typed name. */


 const signerSteps = (view) => {
  const steps = exports.fieldsInOrder.call(void 0, view)
    .filter(f => f.filler === 'family' && f.type !== 'rows')
    .map(f => (f.type === 'signature' ? { kind: 'signature', field: f } : { kind: 'field', field: f }))
  // One name signs every signature box: ask it once, at the first box.
  const first = steps.findIndex(s => s.kind === 'signature')
  if (first < 0) return [...steps, { kind: 'signature' }]
  return steps.filter((s, i) => s.kind !== 'signature' || i === first)
}; exports.signerSteps = signerSteps

 const staffFields = (view) =>
  exports.fieldsInOrder.call(void 0, view).filter(f => f.filler === 'staff' && _optionalChain([view, 'access', _ => _.StaffValues, 'optionalAccess', _2 => _2[f.id], 'optionalAccess', _3 => _3.trim, 'call', _4 => _4()])); exports.staffFields = staffFields

 const rowsFields = (view) => exports.fieldsInOrder.call(void 0, view).filter(f => f.type === 'rows' && f.rows); exports.rowsFields = rowsFields

/* The child the form is about: a staff value labelled for the child, else
 * one labelled as a name, else the patient's name. */
 const childName = (view) => {
  const staff = exports.staffFields.call(void 0, view)
  const pick = _nullishCoalesce(staff.find(f => /child/i.test(f.label)), () => ( staff.find(f => /name/i.test(f.label))))
  return pick ? view.StaffValues[pick.id].trim() : view.PatientName
}; exports.childName = childName

 const isFilled = (field, value) =>
  field.type === 'checkbox' ? value === 'true' : !!_optionalChain([value, 'optionalAccess', _5 => _5.trim, 'call', _6 => _6()]); exports.isFilled = isFilled

/* The month a log covers (UTC first day): LogMonth, else the month it was sent. */
 const logMonth = (view) =>
  _links.isSetTime.call(void 0, view.LogMonth)
    ? _moment2.default.utc(view.LogMonth).startOf('month')
    : _moment2.default.utc(view.CreatedAt).startOf('month'); exports.logMonth = logMonth

/* The day of the log's month a row belongs to, 0 when outside it. A 'next'
 * row has no day, so it goes on the day it was added. */
 const rowDay = (row, month) => {
  if (row.day) return row.day
  const added = _moment2.default.call(void 0, row.added)
  return added.year() === month.year() && added.month() === month.month() ? added.date() : 0
}; exports.rowDay = rowDay

 const itemName = (field) => _optionalChain([field, 'access', _7 => _7.rows, 'optionalAccess', _8 => _8.item, 'optionalAccess', _9 => _9.trim, 'call', _10 => _10()]) || field.label; exports.itemName = itemName

 const resultLabel = { given: 'Given', refused: 'Refused', missed: 'Missed' } ; exports.resultLabel = resultLabel
